import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

export enum PillDesigns {
  Circular = 'circular',
  Regular = 'regular',
}

interface PillProps {
  design: PillDesigns
  className?: string
  selected: boolean
  handleClick: () => void
}

const Pill: React.FC<React.PropsWithChildren<PillProps>> = (
  props,
): React.ReactElement => {
  return (
    <button
      className={props.className}
      css={css`
        ${props.design === PillDesigns.Circular &&
        css`
          height: 40px;
          width: 40px;
          border-radius: 50%;
        `}

        ${props.design === PillDesigns.Regular &&
        css`
          border-radius: 25px;
          height: 40px;
          padding: 12px 16px;
        `}

        cursor: pointer;
        &:nth-child(n + 2) {
          margin-left: 10px;
        }
        ${getFontCss(
          14,
          themeConstants.colors.font_primary,
          styleConstants.fontFamilies.regular,
        )};

        transition:
          background-color ${styleConstants.transitionSpeed.fastest} ease-out,
          border ${styleConstants.transitionSpeed.fastest} ease-out;
        background-color: ${styleConstants.colors.gray_lightest};
        border: 1px solid ${styleConstants.colors.gray_medium};
        &:hover {
          background-color: ${styleConstants.colors.white};
          border: 1px solid ${themeConstants.colors.cta};
        }

        ${props.selected &&
        css`
          background-color: ${themeConstants.colors.cta};
          border: 1px solid transparent;
          ${getFontCss(
            14,
            styleConstants.colors.white,
            styleConstants.fontFamilies.regular,
          )};

          &:hover {
            border: 1px solid transparent;
            background-color: ${themeConstants.colors.cta_dark};
          }
        `}
      `}
      type={'button'}
      onClick={props.handleClick}
    >
      {props.children}
    </button>
  )
}

export default Pill
